<div class="container-fluid">
    <div class="row">
        <div class="col">
            <app-header></app-header>
        </div>
    </div>
    <div class="row main-bg-color">
        <div class="col">
            <div class="custom-container container-fluid">
                <ngx-spinner type="ball-square-spin" size="medium">
                    <p style="color: white"> {{loadingDescription}}... </p>
                </ngx-spinner>
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <div class="footer container-fluid">
                <app-footer></app-footer>
            </div>
        </div>
    </div>
</div>
